import React, { Component } from "react";

import "antd/dist/antd.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./App.css";

import BannerPreview from "./components/preview/BannerPreview";
import ControlBar from "./components/controlBar";

class App extends Component {
  state = {
    headlines: [""],
    descriptions: [""],
    result: [
      {
        headline: "Test 1",
        description: "Test 2"
      }
    ],
    imgSrc: require("./images/950x350-ucla-blue-solid-color-background.jpg")
  };

  render() {
    return (
      <div className="App">
        <ControlBar
          headlineValues={this.state.headlines}
          descriptionValues={this.state.descriptions}
        />
        <BannerPreview />
      </div>
    );
  }
}

export default App;
